import { isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { combineLatest, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import packageJson from '../../package.json';
import { ConfigService } from '../app/services/config/config.service';
import { CryptoService } from '../app/services/crypto/crypto.service';
import { StorageService } from '../app/services/storage/storage.service';
import { AppPasswordService } from './services/app-password/app-password.service';
import { AuthService } from './services/auth/auth.service';
import { WebAuthenticatorService } from './services/auth/web-authenticator.service';
import { CryptoWalletService } from './services/crypto-wallet/crypto-wallet.service';
import { EventTransportService } from './services/event-transport/event-transport.service';
import { LoggerService } from './services/logger/logger.service';
import { EVMProviderFactoryService } from './services/provider/evm-provider-factory.service';
import { SessionService } from './services/session/session.service';
import { ThemeService } from './services/theme/theme.service';
import { eVersionService } from './services/version/version-service';
import { WalletConnectService } from './services/wallet-connect/wallet-connect.service';
import { SwUpdateService } from '@services/sw-update/sw-update.service';

// @ts-ignore
// @ts-ignore
// import { PostsetupService } from './services/postsetup/postsetup.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [ './app.component.scss' ],
})
export class AppComponent implements OnInit
{
    private eventSubscription: Subscription;
    public showIndexDBAlert: boolean;
    public showUpdateAlert: boolean;
    public alertDescription: string;
    public isSignMessageActive: boolean = false;

    public address: string;
    public msg: string;

    constructor(
        private provider: EVMProviderFactoryService,
        private translateService: TranslateService,
        private idb: NgxIndexedDBService,
        private cryptoWallet: CryptoWalletService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private webAuthnService: WebAuthenticatorService,
        private themeService: ThemeService,
        private passwordService: AppPasswordService,
        private sessionService: SessionService,
        // private postsetupService: PostsetupService,
        private walletConnect: WalletConnectService,
        private eventTransport: EventTransportService,
        private versionService: eVersionService,
        private config: ConfigService,
        private storage: StorageService,
        private cryptoService: CryptoService,
        private logger: LoggerService,
        private router: Router,
        private authService: AuthService,
        private swUpdate: SwUpdateService,
    )
    {
        console.log('CyberWallet v.' + packageJson.version);
        this.swUpdate.init();
        this.setupLanguages();
        // this.setupClientKeys();
        combineLatest([
            this.router.events,
            this.authService.lockState,
            this.authService.loginState
        ]).subscribe(async (event) =>
        {
            if (event[ 0 ] instanceof NavigationStart)
            {
                if (event[ 0 ].url.startsWith('/unlock') && !event[ 1 ])
                {
                    this.router.navigate([ '/wallets' ]);
                }
                if (event[ 0 ].url.startsWith('/sign-in') && event[ 2 ])
                {
                    this.router.navigate([ '/wallets' ]);
                }
            }
        });
    }

    async ngOnInit()
    {
        this.eventSubscription = this.eventTransport
            .on('show-index-db-alert')
            .subscribe(async (args) =>
            {
                this.showIndexDBAlert = true;
            });

        this.eventSubscription.add(this.eventTransport
            .on('confirm-signMsg')
            .subscribe(async (_data) =>
            {
                if (!!_data)
                {
                    this.address = _data.data.walletAddress;
                    this.msg = _data.data.message;
                    this.isSignMessageActive = true;
                }
            }))

        if (isPlatformServer(this.platformId)) return;

        this.setupLanguages();

        localStorage.setItem('exchange', JSON.stringify({}));
        this.versionService.updateAvailable.subscribe(
            this.OnUpdateAvailable.bind(this)
        );

        this.versionService.CheckUpdate();
    }

    private async OnUpdateAvailable(_version: string)
    {
        let walletName = await this.translateService
            .get('WALLET.ON-TESTNET')
            .pipe(take(1))
            .toPromise();

        this.alertDescription = await this.translateService
            .get('COMMON.UPDATE-ALERT.DESCRIPTION', {
                new_version: _version,
                app_version: walletName + ' ' + packageJson.version,
            })
            .pipe(take(1))
            .toPromise();

        this.showUpdateAlert = true;
    }

    public async UpdateToLastVersion()
    {
        this.HideUpdateAlert();

        try
        {
            await this.versionService.Update();
            document.location.reload();
        } catch (err)
        {
            //todo show something
        }
    }

    public HideUpdateAlert()
    {
        this.showUpdateAlert = false;
    }

    public HideIndexDBAlert()
    {
        this.showIndexDBAlert = false;
    }

    private setupLanguages()
    {
        const langs = [ 'en', 'ja', 'zh' ];

        this.translateService.addLangs(langs);
        this.translateService.setDefaultLang('en');

        let language = 'en';

        const langFromStorage = localStorage.getItem('language');

        language = langFromStorage;

        if (!langFromStorage)
        {
            navigator.languages.some((_navLang) =>
            {
                const lang = langs.find((_lang) => _navLang.startsWith(_lang));

                if (lang)
                {
                    language = lang;

                    return true;
                }

                return false;
            });
        }

        language = language || 'en';

        if (!langs.includes(language)) language = 'en';

        this.translateService.use(language);

        localStorage.setItem('language', language);

        this.translateService.onLangChange.subscribe(({ lang }) =>
        {
            localStorage.setItem('language', lang);
        });
    }

    public hideSign()
    {
        this.isSignMessageActive = false;
    }
}
